import React from 'react';
import { useState, useEffect } from 'react';
import './centum-input.css';

interface IInput {
    type: 'text' | 'button' | 'checkbox' | 'radio';
    id: string;
    name?: string;
    width?: number;
    enable?: any;
    height?: number;
    value?: any;
    checked?: boolean;
    onClick?: () => void;
    onChange?: (id: any, value: any, name?: string) => void;
}

function CentumInput(props: IInput) {
    const { type, width = 130, height = 20, id, name, checked = false, onClick, onChange } = props;

    const [tempValue, setTempValue] = useState(props.value);
    const [isChecked, setIsChecked] = useState(checked);

    const ChangeValue = (event: React.ChangeEvent<HTMLInputElement>, id: string, name?: string) => {
        setTempValue(event.target.value);
        if (onChange) onChange(id, event.target.value, name);
    };

    function Change(event: React.ChangeEvent<HTMLInputElement>) {
        setTempValue(event.target.value);
    }

    const ChangeValueRadio = (event: React.ChangeEvent<HTMLInputElement>, id: string) => {
        if (event && event.target) {
            if (onChange) {
                onChange(id, event.target.value);
            }
        }
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newChecked = event.target.checked;
        setIsChecked(newChecked);
        if (onChange) {
            onChange(id, newChecked, name);
        }
    };

    React.useEffect(() => {
        setTempValue(props.value);
    }, [props.value]);

    let input = <></>;

    switch (type) {
        case 'text':
            input = (
                <div className="type-input" style={{ width: `${width}px`, height: `${height}px` }}>
                    <input
                        type="text"
                        value={tempValue}
                        onChange={Change}
                        onBlur={(e) => ChangeValue(e, id, name)}
                        disabled={!props.enable}
                    />
                </div>
            );
            break;

        case 'button':
            input = (
                <button
                    className="type-button"
                    type="button"
                    onClick={onClick}
                    style={{ width: `${width}px`, height: `${height}px` }}>
                    {props.value}
                </button>
            );
            break;
        case 'checkbox':
            input = (
                <input
                    disabled={!props.enable}
                    className="type-checkbox"
                    id={id}
                    name={name}
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                />
            );
            break;
        case 'radio':
            input = (
                <input
                    className="type-radio"
                    id={id}
                    disabled={props.enable}
                    value={id}
                    name={name}
                    type="radio"
                    checked={checked}
                    onChange={(e) => ChangeValueRadio(e, id)}
                />
            );
            break;
    }

    return input;
}

export default CentumInput;
